var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-tips-container flex items-center",on:{"click":_vm.buyMember}},[_c('img',{attrs:{"src":"https://files.wondercv.com/pc-cvs/vip-icon.png","alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-tips-text"},[_c('span',[_vm._v("开通会员")]),_vm._v("体验完整面试")])
}]

export { render, staticRenderFns }